import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/router";
import React from "react";
import Icon from "~/components/Icon";
import Input from "~/components/Input";
import ModalContainer from "~/components/Modals/ModalContainer";

import PinterestIcon from "~/assets/svgs/pinterest.svg";
import TwitterIcon from "~/assets/svgs/twitter.svg";
import FacebookIcon from "~/assets/svgs/fb.svg";

import Colors from "~/constants/colors";

type Props = {
  title: string;
  image: string;
};

const SocialShare = ({ title, image }: Props) => {
  const router = useRouter();
  const [isCopy, setCopy] = React.useState(false);
  const [showModal, setShowModal] = React.useState(false);
  const url = !!process.env.NEXT_PUBLIC_URL
    ? `${process.env.NEXT_PUBLIC_URL}${router.asPath}`
    : document.URL;
  const handleSocialShare = (name: string) => {
    switch (name) {
      // case "facebook":
      //   window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}`);
      //   break;
      // case 'twitter':
      //   window.open(
      //     `https://twitter.com/intent/tweet?text=${title}&&url=${url}`,
      //   )
      //   break
      // case 'pinterest':
      //   window.open(
      //     `https://pinterest.com/pin/create/button/?url=${url}&description=${title}&media=${image}`,
      //   )
      //   break

      // case 'linkedin':
      //   window.open(
      //     `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
      //       url,
      //     )}`,
      //   )
      //   break

      default:
        break;
    }
  };

  const handleCopyLink = () => {
    navigator.clipboard.writeText(url);
    setCopy(true);
    // setTimeout(() => {
    //   setCopy(false);
    // }, 2000);
  };
  return (
    <>
      <div
        className="w-10 h-10 shadow rounded-full cursor-pointer flex items-center justify-center bg-white"
        onClick={() => setShowModal(true)}
        title="Share link product"
      >
        <Icon name="share" onClick={() => handleSocialShare("twitter")} />
      </div>
      <ModalContainer
        open={showModal}
        width={856}
        onClose={() => {
          setShowModal(false);
          setCopy(false);
        }}
        title={"Share link"}
        className="h-40"
      >
        <div>
          <div className="flex mb-2">
            <Input
              value={url}
              className="flex-1"
              suffix={
                <img
                  src={isCopy ? "/svgs/copy-success.svg" : "/svgs/copy.svg"}
                  alt="copy"
                  onClick={handleCopyLink}
                  width={32}
                  height={32}
                />
              }
            />
          </div>
          <div className="flex gap-2">
            <Link
              href={`https://www.facebook.com/sharer/sharer.php?u=${url}`}
              target="_blank"
            >
              <FacebookIcon
                alt="Star"
                width={32}
                height={32}
                onClick={() => handleSocialShare("facebook")}
                className="cursor-pointer "
                color={Colors.PRIMARY}
              />
            </Link>
            <Link
              href={`https://twitter.com/intent/tweet?text=${title}&&url=${url}`}
            >
              <TwitterIcon
                alt="Star"
                width={32}
                height={32}
                onClick={() => handleSocialShare("twitter")}
                color={Colors.PRIMARY}
              />
            </Link>
            <Link
              href={`https://pinterest.com/pin/create/button/?url=${url}&description=${title}&media=${image}`}
              target="_blank"
            >
              <PinterestIcon
                color={Colors.PRIMARY}
                alt="Star"
                width={32}
                height={32}
                onClick={() => handleSocialShare("twitter")}
              />
            </Link>
          </div>
        </div>
      </ModalContainer>
    </>
  );
};

export default SocialShare;
